export function promiseSeries(promise_constructors: (() => Promise<void>)[]): Promise<void> {
	return promise_constructors.reduce(async (previous_promise, next_promise) => {
		await previous_promise;
		return await next_promise();
	}, Promise.resolve());
}

export function Throttle(): { (callback: () => void): void; cancel(): void } {
	let busy = false;
	let cancel = false;
	const throttle = (callback: () => void) => {
		if (busy || cancel) {
			return;
		}
		busy = true;
		requestAnimationFrame(() => {
			busy = false;
			if (!cancel) {
				callback();
			}
		});
	};
	throttle.cancel = () => {
		cancel = true;
	};
	return throttle;
}

export function createCSVBlob(raw_csv_string: string): Blob {
	return new Blob(["\ufeff" + raw_csv_string], { type: "text/csv;charset=utf-8;" });
}

const numberFormatterCache = new Map<string, Intl.NumberFormat>();

export function numberToLocaleString(num: number): string {
	const locale = window.navigator.language || window.navigator.languages[0];
	if (!numberFormatterCache.has(locale)) {
		numberFormatterCache.set(
			locale,
			Intl.NumberFormat(locale, {
				maximumFractionDigits: 20,
			})
		);
	}
	return numberFormatterCache.get(locale)!.format(num);
}

export function pad(value: string, pad_length: number, pad_string: string): string {
	const value_length = value.length;
	const fill_length = pad_length - value_length;
	if (fill_length <= 0) {
		return value;
	}
	const character_length = pad_string.length;
	let padded_string = "";
	for (let i = 0; i < fill_length; i += character_length) {
		padded_string += pad_string;
	}
	return padded_string.slice(0, fill_length).concat(value);
}

export function raw_state_name<S extends string>(raw_state: S | [S, any]): S {
	if (raw_state instanceof Array) {
		return raw_state[0];
	}
	return raw_state;
}
